import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Chi tiết kế hoạch")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "las la-reply" }, null, -1)
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Thông tin kế hoạch sửa chữa")
], -1)
const _hoisted_7 = { class: "row pb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fw-bold text-muted" }, "ID:", -1)
const _hoisted_9 = { class: "col-lg-6" }
const _hoisted_10 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_11 = { class: "row pb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Tên kế hoạch:", -1)
const _hoisted_13 = { class: "col-lg-6" }
const _hoisted_14 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_15 = { class: "row pb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Tháng:", -1)
const _hoisted_17 = { class: "col-lg-8" }
const _hoisted_18 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_19 = { class: "row pb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Ghi chú:", -1)
const _hoisted_21 = { class: "col-lg-6" }
const _hoisted_22 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_23 = { class: "row pb-4" }
const _hoisted_24 = { class: "col-2" }
const _hoisted_25 = { class: "card-body p-9" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Thông tin toa xe")
], -1)
const _hoisted_27 = { class: "row pb-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fw-bold text-muted" }, "ID:", -1)
const _hoisted_29 = { class: "col-lg-6" }
const _hoisted_30 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_31 = { class: "row pb-4" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fw-bold text-muted" }, "Tên:", -1)
const _hoisted_33 = { class: "col-lg-6" }
const _hoisted_34 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_35 = { class: "row pb-4" }
const _hoisted_36 = { class: "col-3" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-5 fw-bold text-muted" }, "Mã toa xe: ", -1)
const _hoisted_39 = { class: "col-lg-7" }
const _hoisted_40 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_41 = { class: "col-3" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Số hiệu: ", -1)
const _hoisted_44 = { class: "col-lg-8" }
const _hoisted_45 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_46 = { class: "row pb-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fw-bold text-muted" }, "Mô tả:", -1)
const _hoisted_48 = { class: "col-lg-10" }
const _hoisted_49 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_50 = { class: "row pb-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-1 fw-bold text-muted" }, "Ghi chú:", -1)
const _hoisted_52 = { class: "col-lg-10" }
const _hoisted_53 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_54 = { class: "row pb-4" }
const _hoisted_55 = { class: "col-3" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Ngày tạo:", -1)
const _hoisted_58 = { class: "col-lg-8" }
const _hoisted_59 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_60 = { class: "col-4" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Ngày chỉnh sửa:", -1)
const _hoisted_63 = { class: "col-lg-8" }
const _hoisted_64 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_65 = { class: "card-body p-9" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "row pb-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Danh sách vật tư")
], -1)
const _hoisted_68 = {
  key: 1,
  class: "card-title m-0"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Chưa có vật tư nào được chọn", -1)
const _hoisted_70 = [
  _hoisted_69
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_SelectedSupplies = _resolveComponent("SelectedSupplies")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: "/quan-ly/ke-hoach-sua-chua",
          class: "btn btn-primary align-self-center"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: '/quan-ly/ke-hoach-sua-chua/cap-nhat/' + _ctx.planId,
          class: "btn btn-success align-self-center ms-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art005.svg" })
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.planId), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.planName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.planMonth), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.planNote ? _ctx.planNote : "-"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_el_button, { onClick: _ctx.newDissolutionReportClickedHandler }, {
            default: _withCtx(() => [
              _createTextVNode("Tạo biên bản giải thế")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.productItem.id), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.productItem.ten_san_pham), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.productItem.ma_san_pham), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.productItem.so_hieu), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.productItem.mo_ta), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.productItem.ghi_chu), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.formatDate(_ctx.productItem.created_at).format("DD/MM/YYYY hh:mm")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _hoisted_62,
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.formatDate(_ctx.productItem.updated_at).format("DD/MM/YYYY hh:mm")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _hoisted_67,
        (_ctx.selectedSupplies.length > 0)
          ? (_openBlock(), _createBlock(_component_SelectedSupplies, {
              key: 0,
              isCreated: false,
              items: _ctx.selectedSupplies,
              onOnDeleteClicked: () => {}
            }, null, 8, ["items"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_70))
      ])
    ])
  ]))
}